"use client";
import { jsx } from "react/jsx-runtime";
import React from "react";
import MuiGrid from "@mui/material/Grid2";
import { SpaceLg, SpaceMd } from "@nxt-costco-com/forge-design-tokens";
import { COMPONENT_NAME } from "./constants.js";
const Grid = ({
  children,
  hasMargin = true,
  container,
  sx: userSx = {},
  // Destructure sx here and provide a default value
  ...otherProps
}) => {
  const shouldApplyMargin = container && hasMargin;
  const getSx = () => {
    const containerStyles = shouldApplyMargin ? {
      marginLeft: { sm: SpaceMd, lg: SpaceLg },
      marginRight: { sm: SpaceMd, lg: SpaceLg }
    } : {};
    return {
      ...userSx,
      // Apply user-defined styles first
      ...shouldApplyMargin && containerStyles
      // Conditionally apply container styles
    };
  };
  return /* @__PURE__ */ jsx(
    MuiGrid,
    {
      container,
      sx: getSx(),
      "data-testid": COMPONENT_NAME,
      ...otherProps,
      children: Array.isArray(children) ? children.map((child, index) => /* @__PURE__ */ jsx(React.Fragment, { children: child }, index)) : children
    }
  );
};
Grid.displayName = COMPONENT_NAME;
export {
  Grid
};
